import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { AlertDialogComponent } from 'src/app/alert-dialog/alert-dialog.component';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { serverMessage } from 'src/app/popUpMessages/serverMessage';
import { ConfigurationMvbloComponent } from '../configuration-MVBLO/configuration-mvblo/configuration-mvblo.component';
//import { ConfigurationMvbloComponent } from '../configuration-mvblo/configuration-mvblo.component';
import { messages } from 'src/app/popUpMessages/messages';

import { ViewChild } from '@angular/core';
import { Tree } from 'primeng/tree';

import { TreeNode } from 'primeng/api';
import { KmatDto } from 'src/app/models/KmatDto';

interface Node {
  name: string;
  id?: number;
  selected?: boolean;
  indeterminate?: boolean;
  children?: Node[];
  type?: string;
}
@Component({
  selector: 'app-configuration-vblo',
  templateUrl: './configuration-vblo.component.html',
  styleUrls: ['./configuration-vblo.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ConfigurationVBLOComponent implements OnInit {
  public rowData: any = [];
  public defaultColDef: any;
  public columnDefs: any = [];
  public gridApi: any;
  public gridColumnApi: any;
  public domLayout: any;
  public rowHeight: any;
  public headerHeight: any;
  public Editable: boolean = true;
  public alertErrorBox = [];
  public errorMessage = []
  public loggedInUser: any;
  public getResponse: any;
  public frameworkComponents: any;
  public idGenerated: number = 1;

  public sizeToFitRefresh: number = 0;
  public showGrid = false;
  submitResponse: any;
  receivedNodes: any;
  showTree: boolean;
  public selectedDataKmat: any;
  public selectedNode: any;
  public flatdata = [];
  public projectIdFromLocal: any;
  public addedVblo: any = [];
  public removedVblo: any = [];
  recKmatVblo: any;
  dbSelectedNodeIds: any = [];
  hasUnsavedChanges: boolean;
  public submitted: boolean = false;
  public kmatData: any;
  rowClassRules: any;
  public kmatVbloData: any;
  public configurationData: any;
  submitClicked: boolean;
  projectId: any;
  public allKmatData: KmatDto[];
  selectedKMAT: number = 0;
  kmatUnselectedStore: { [kmatId: number]: string[] } = {};
  kmatBackendMaterialStore: { [kmatId: number]: string[] } = {};
  initialPrimaryKmatId: number | null = null;
  primaryKmatChanged: boolean = false;
  lastPrimaryKmatId: number | null = null;
  public leadingKmatColumnDisabled: boolean = true;

  @ViewChild('vbloTree') vbloTree: Tree;
  kmatVbloMaterialData: TreeNode[] = [];
  // Store selected nodes for each KMAT
  kmatSelectionStore: { [kmatId: number]: TreeNode[] } = {};

  selectedMaterials: TreeNode[] = [];

  selectedNodeKeys: string[] = [];

  selectedNodes: TreeNode[] = [];
  keyNumber: number;
  selectedSubtrees: TreeNode<any>[] = [];

  constructor(
    private sharedService: SharedServiceService,
    public dialog: MatDialog,
    private localStorageService: LocalStorageService,
    private router: Router,
    private configuration: ConfigurationService,
  ) { }

  ngOnInit(): void {
    this.sharedService.getProjectIdAndTitle();
    this.projectId = this.localStorageService.get("projectId");
    this.configuration.getKmatData(this.projectId, this.localStorageService.get("ConfigId")).subscribe(d => {
      let errorMsgeFromBack = d.Data.Message;
      if (d.StatusCode == 200) {
        this.allKmatData = d.Data;
        // this.allKmatData.forEach(kmat => {
        //   kmat.selected = kmat.IsLinkedToConfiguration === true;
        // });
        //this.rowData = this.allKmatData;
        // Mark grid selection based on kmat.selected

        // this.allKmatData.forEach(kmat => {
        //   kmat.selected = kmat.IsLinkedToConfiguration === true;
        // });

        // Now count selected
        // const selectedCount = this.allKmatData.filter(kmat => kmat.selected).length;
        // this.leadingKmatColumnDisabled = selectedCount <= 1;



        setTimeout(() => {
          if (this.gridApi && this.allKmatData) {
            const nonPrimaryPromises: Promise<any>[] = [];
            this.gridApi.forEachNode((node: any) => {
              if (node.data.IsLinkedToConfiguration === true && node.data.Isprimary !== true) {
                node.setSelected(true);
                const kmatId = node.data.KMATId;
                nonPrimaryPromises.push(this.loadAllData(kmatId,false));
                // this.loadAllData(kmatId);
              }
             
            });

            Promise.all(nonPrimaryPromises).then(() => { 
              const primaryKmat = this.allKmatData.find(kmat => kmat.Isprimary);
              if (primaryKmat) {
                this.selectedKMAT = primaryKmat.KMATId;
                this.initialPrimaryKmatId = primaryKmat.KMATId;
                this.lastPrimaryKmatId = primaryKmat.KMATId;
                this.loadAllData(this.selectedKMAT,true);

                const selectedCount = this.allKmatData.filter(kmat => kmat.selected).length;
                this.leadingKmatColumnDisabled = selectedCount <= 1;
              }
               this.gridApi.redrawRows();
              // this.gridApi.refreshCells({ columns: ['Isprimary'], force: true });
            });
          }

        }, 0);
      } else {
        //Show errorCode and errorMessage in the UI
        let errorContainer = [
          { [serverMessage.serverErrorMessage]: serverMessage.serverErrorHeader },
          { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
        ]
        this.openAlertDialog(errorContainer);
      }
    },
      (error) => {
        //Show errorCode and errorMessage in the UI
        this.openAlertDialog([{ [serverMessage.serverAPIerror]: serverMessage.serverErrorHeader }])
      });
    this.loadGrid();
    // this.loadAllData();

    (window as any).angularComponentRef = {
      onPrimaryKmatChange: (kmatId: number) => {
        const currentPrimary = this.allKmatData.find(kmat => kmat.Isprimary);

        if (currentPrimary && currentPrimary.IsLinkedToConfiguration === true && currentPrimary.KMATId !== kmatId) {
          // this.openAlertDialog([{ 'You are changing the leading KMAT. This will result in a loss of all planning data in EQ Target Costs screen. Are you sure you want to continue?': 'Warning: Plan data will be deleted' }]);
          // this.sharedService.configurationOnClickOk.subscribe(
          //   () => {
          this.allKmatData.forEach(kmat => {
            kmat.Isprimary = (kmat.KMATId === kmatId);
          });

          if (this.lastPrimaryKmatId !== kmatId) {
            this.primaryKmatChanged = true;
            this.lastPrimaryKmatId = kmatId;
          }

          // Refresh grid to reflect the change
          if (this.gridApi) {
            this.gridApi.refreshCells({ force: true });
          }
          //   }
          // );

          // If Cancel, do nothing (do not update Isprimary)
          // this.sharedService.configurationOnClickCancel.subscribe(
          //   () => {
          //     // Optionally, refresh grid to revert visual selection
          //     if (this.gridApi) {
          //       this.gridApi.refreshCells({ force: true });
          //     }
          //   }
          // );
        } else {
          this.allKmatData.forEach(kmat => {
            kmat.Isprimary = (kmat.KMATId === kmatId);
            this.lastPrimaryKmatId = kmatId;
          });
          if (this.gridApi) {
            this.gridApi.refreshCells({ force: true });
          }
        }
      }
    }

  }

  loadGrid() {
    this.showGrid = true;
    this.columnDefs = [
      {
        field: "selected",
        headerName: "Selected",
        checkboxSelection: true,
        editable: false,
       // cellClass: 'disable-checkbox',
        width: 80
      },
      {
        headerName: "KMAT",
        field: "KMAT",
        headerTooltip: "KMAT",
        width: 100,
        editable: false,
      },
      {
        headerName: "KMAT Text",
        field: "KMATName",
        headerTooltip: "KMAT Text",
        width: 200,
        editable: false,
      },
      {
        headerName: "Plant",
        field: "Plant",
        headerTooltip: "Plant",
        width: 120,
        editable: false,
      },
      {
        headerName: "SAP Status",
        field: "Status",
        headerTooltip: "SAP Status",
        editable: false,
        width: 120,
      },
      {
        field: "Isprimary",
        headerName: "Leading KMAT",
        checkboxSelection: false,
        width: 120,
        cellRenderer: (params) => {
          // const disabled = this.leadingKmatColumnDisabled ? "disabled" : "";
                    const onlyOneSelected = this.countSelectedKmats() <= 1;
          const disabled = (!params.data?.selected || onlyOneSelected) ? "disabled" : "";
          return `<div class="ngSelectionCell">
            <input name="Isprimary"
                   type="radio"
                   style="accent-color: red; height: 2em; width: 18px;"
                              ${params.data.Isprimary ? "checked" : ""}
                              ${disabled}
                   onclick="window.angularComponentRef.onPrimaryKmatChange(${params.data.KMATId})">
          </div>`;
        },
      },
    ];

    this.defaultColDef = {
      sortable: true,
      filter: true,
    }

    this.rowClassRules = {
      'highlight-kmat-row': (params) => params.data && params.data.KMATId === this.selectedKMAT
    };
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi
    this.sizeToFitRefresh = 1;
  }

  onGridSizeChanged(params) {
    params.api.sizeColumnsToFit();
  }

  onDisplayedColumnsChanged(event) {
    if (this.sizeToFitRefresh != 0) {
      this.gridApi.sizeColumnsToFit();
    }
  }

   private countSelectedKmats(): number {
    return (this.allKmatData || []).filter(k => k.selected).length;
  }

  filterKMAT(searchText: string) {
    this.gridApi.setQuickFilter(searchText);
  }

  onKmatSelected(event) {
    this.selectedNodeKeys = [];
    if (this.vbloTree) {
      this.vbloTree.resetFilter();
    }

    // Update current KMAT
    this.selectedKMAT = event.node.data.KMATId;

    this.loadAllData(this.selectedKMAT,true);
    if (this.gridApi) {
      this.gridApi.redrawRows();
    }
  }

  loadAllData(kmatId: number, canCallRefreshKmat: boolean): Promise<void> {
    return new Promise((resolve) => {
      this.showGrid = false;
      this.configurationData = this.localStorageService.get("configuration");
      this.kmatData = kmatId;


      this.kmatVbloMaterialData = [];

      this.configuration.getVBLOData(this.projectId, this.configurationData.configurationId, this.kmatData).subscribe((data: any) => {
        this.showGrid = true;
        let errorMsgeFromBack = data.Data.Message;
        if (data.StatusCode == 200) {

          const storedKeys = this.kmatSelectionStore[kmatId];
          if (storedKeys && Array.isArray(storedKeys)) {
            this.selectedNodes = storedKeys;
          } else {
            this.selectedNodes = [];
          }

          this.kmatVbloData = data.Data.map(d => {
            return {
              KMATId: d.KMATId,
              KMATName: d.KMATName,
              children: d.VBLOs,
            }
          });

          this.kmatVbloMaterialData = data.Data.map(d => {
            return {
              key: `KMAT-${d.KMATId}`,
              data: { KMATId: d.KMATId },
              label: d.KMATName,
              expanded: true,

              children: d.VBLOs.map(v => {
                return {
                  key: `KMAT-${d.KMATId}-VBLO-${v.KMATVBLOId}`,
                  data: { KMATVBLOId: v.KMATVBLOId },
                  label: v.VBLOName,

                  children: v.Components.map(component => {
                    return {
                      key: `KMAT-${d.KMATId}-VBLO-${v.KMATVBLOId}-COMP-${component.Component}`,
                      label: component.ComponentName,
                      data: { Component: component.Component },

                      children: component.Materials.map(m => {
                        return {
                          key: `KMAT-${d.KMATId}-VBLO-${v.KMATVBLOId}-COMP-${component.Component}-MAT-${m.VBLOMaterialId}`,
                          data: { VBLOMaterialId: m.VBLOMaterialId, Material: m.Material, IsLinkedToMaterial: m.IsLinkedToMaterial },
                          label: m.MaterialName
                        }
                      })
                    }
                  })
                }
              })
            }
          })

          // Automatically select materials based on IsLinkedToMaterial
          this.kmatVbloMaterialData.forEach(node => {
            this.markIsLinkedMaterials(node);
          });

          let backendMaterialIds: string[] = [];
          const collectMaterialIds = (nodes: TreeNode[]): string[] => {
            let ids: string[] = [];
            nodes.forEach(n => {
              if (n.data?.IsLinkedToMaterial && (n.data?.VBLOMaterialId || n.data?.Material)) {
                ids.push(n.data.VBLOMaterialId || n.data.Material);
              }
              if (n.children) {
                ids = ids.concat(collectMaterialIds(n.children));
              }
            });
            return ids;
          };
          this.kmatBackendMaterialStore[kmatId] = collectMaterialIds(this.kmatVbloMaterialData);



          const unselectedIds = this.kmatUnselectedStore[kmatId] || [];
          if (unselectedIds.length > 0) {
            this.selectedNodes = this.selectedNodes.filter(
              node => {
                const id = node.data?.VBLOMaterialId || node.data?.Material;
                return !unselectedIds.includes(id);
              }
            );
          }

          //console.log("kmatUnselectedStore:", this.kmatUnselectedStore);

          this.updateParentSelectionStates(this.kmatVbloMaterialData, kmatId);

          //console.log("Selected Nodes:", this.selectedNodes);

          // Update kmatSelectionStore with selected items

          this.kmatSelectionStore[kmatId] = this.selectedNodes;

          //this.setParentReferences(this.kmatVbloMaterialData);

          // console.log("this.kmatSelectionStore----", this.kmatSelectionStore);

          if(canCallRefreshKmat)
          {
          this.refreshKmatSelectionsFromStore();
          }
          resolve();
        }
        else {

          //Show errorCode and errorMessage in the UI
          let errorContainer = [
            { [serverMessage.serverErrorMessage]: serverMessage.serverErrorHeader },
            { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
          ]
          this.openAlertDialog(errorContainer);
          resolve();
        }
      },
        (error) => {
          this.openAlertDialog([{ [serverMessage.serverAPIerror]: serverMessage.serverErrorHeader }]);
          resolve();
        })
    });
  }

  refreshKmatSelectionsFromStore() {
    // Get all KMAT IDs that have selections in kmatSelectionStore
    const selectedKmatIds = Object.keys(this.kmatSelectionStore)
      .map(id => Number(id))
      .filter(id => this.kmatSelectionStore[id] && this.kmatSelectionStore[id].length > 0);

    // Mark KMATs as selected in allKmatData
    this.allKmatData.forEach(kmat => {
      const wasSelected = kmat.selected;
      kmat.selected = selectedKmatIds.includes(kmat.KMATId);

      // If KMAT becomes unselected, remove its primary status
      if (wasSelected && !kmat.selected) {
        kmat.Isprimary = false;
        if (this.lastPrimaryKmatId === kmat.KMATId) {
          this.lastPrimaryKmatId = null;
          this.primaryKmatChanged = true;
        }
      }
    });

    const selectedCount = this.allKmatData.filter(kmat => kmat.selected).length;
    this.leadingKmatColumnDisabled = selectedCount <= 1;

    //If only one KMAT is selected, make it primary automatically
    if (selectedCount === 1) {
      const onlySelectedKmat = this.allKmatData.find(kmat => kmat.selected);
      if (onlySelectedKmat) {
        onlySelectedKmat.Isprimary = true;
        this.lastPrimaryKmatId = onlySelectedKmat.KMATId;
      }
    }

    // Update ag-Grid visual selection
    if (this.gridApi) {
      this.gridApi.forEachNode(node => {
        node.setSelected(selectedKmatIds.includes(node.data.KMATId));
      });
      this.gridApi.refreshCells({ columns: ['Isprimary'], force: true });
    }

    // Restore selectedNodes for current KMAT
    if (this.selectedKMAT && this.kmatSelectionStore[this.selectedKMAT]) {
      this.selectedNodes = [...this.kmatSelectionStore[this.selectedKMAT]];
    } else {
      this.selectedNodes = [];
    }
  }

  setParentReferences(nodes: TreeNode[], parent: TreeNode | null = null) {
    nodes.forEach(node => {
      node.parent = parent;
      if (node.children) {
        this.setParentReferences(node.children, node);
      }
    });
  }

  markIsLinkedMaterials(node: TreeNode) {
    if (!node) return;

    if (node.children) {
      for (const child of node.children) {
        this.markIsLinkedMaterials(child);
      }
    }

    // If the material is linked, add it to the selected nodes
    if (node.data?.IsLinkedToMaterial === true) {
      // If the node is not already selected, add it
      if (!this.selectedNodes.some(n => n.key === node.key)) {
        this.selectedNodes.push(node);
      }
    }

  }

  assignKeys(tree: TreeNode[]) {
    tree.forEach(n => {
      n.key = this.keyNumber.toString();
      this.keyNumber++;
      if (n.children) {
        this.assignKeys(n.children);
      }
    })
  }

  selectAllChildren(tree: TreeNode[]) {
    tree.forEach(n => {
      this.selectedNodes.push(n);
      if (n.children) {
        this.selectAllChildren(n.children);
      }
    })
  }

  onTreeSelectionChange(event: TreeNode[]) {
    if (this.selectedKMAT) {
      if (event.length === 0) {
        delete this.kmatSelectionStore[this.selectedKMAT];
      }
      else {
        this.kmatSelectionStore[this.selectedKMAT] = [...event];
      }

      this.refreshKmatSelectionsFromStore();
    }
  }

  // Utility to get all descendant keys
  getDescendantKeys(node: TreeNode): string[] {
    let keys: string[] = [];
    if (node.children) {
      for (const child of node.children) {
        keys.push(child.key);
        keys = keys.concat(this.getDescendantKeys(child));
      }
    }
    return keys;
  }

  onNodeToggle(node: TreeNode, checked: boolean) {
    if (checked) {
      // Add node and all descendants to selectedNodes
      const addNodes = [node, ...this.getDescendantNodes(node)];
      addNodes.forEach(n => {
        if (!this.selectedNodes.includes(n)) {
          this.selectedNodes.push(n);
        }
      });

      // Remove from unselected store only if originally linked from backend
      if (this.selectedKMAT) {
        const reselectedIds = addNodes
          .filter(n => n.data?.IsLinkedToMaterial && (n.data?.VBLOMaterialId || n.data?.Material))
          .map(n => n.data.VBLOMaterialId || n.data.Material)
          .filter(id => !!id);

        const prevUnselected = this.kmatUnselectedStore[this.selectedKMAT] || [];
        this.kmatUnselectedStore[this.selectedKMAT] = prevUnselected.filter(id => !reselectedIds.includes(id));
      }
    } else {
      // Remove node and all descendants from selectedNodes
      const removeNodes = [node, ...this.getDescendantNodes(node)];
      this.selectedNodes = this.selectedNodes.filter(n => !removeNodes.includes(n));

      // Track unselected material IDs for this KMAT, only if originally linked from backend
      if (this.selectedKMAT) {
        const unselectedIds = removeNodes
          .filter(n => n.data?.IsLinkedToMaterial && (n.data?.VBLOMaterialId || n.data?.Material))
          .map(n => n.data.VBLOMaterialId || n.data.Material)
          .filter(id => !!id);

        const prevUnselected = this.kmatUnselectedStore[this.selectedKMAT] || [];
        this.kmatUnselectedStore[this.selectedKMAT] = Array.from(new Set([...prevUnselected, ...unselectedIds]));
      }
    }

    // Always check parent selection after any toggle
    this.updateParentSelection(node.parent);

    // Store selection for current KMAT
    if (this.selectedKMAT) {
      if (this.selectedNodes.length === 0) {
        // Remove KMAT from selection store if nothing is selected
        delete this.kmatSelectionStore[this.selectedKMAT];
      } else {
        this.kmatSelectionStore[this.selectedKMAT] = [...this.selectedNodes];
      }
    }

    this.refreshKmatSelectionsFromStore();
  }

  // Utility to get all descendant nodes
  getDescendantNodes(node: TreeNode): TreeNode[] {
    let nodes: TreeNode[] = [];
    if (node.children) {
      for (const child of node.children) {
        nodes.push(child);
        nodes = nodes.concat(this.getDescendantNodes(child));
      }
    }
    return nodes;
  }

  updateParentSelectionStates(nodes: TreeNode[], kmatId: number) {
    if (!nodes) return;
    nodes.forEach(node => {
      if (node.children && node.children.length > 0) {
        // Recursively update children first
        this.updateParentSelectionStates(node.children, kmatId);

        const selectedChildren = node.children.filter(child => this.selectedNodes.some(n => n.key === child.key));
        const partialChildren = node.children.filter(child => child.partialSelected);

        if (selectedChildren.length === node.children.length && partialChildren.length === 0) {
          node.partialSelected = false;
          // Select parent if all children are selected and node belongs to current KMAT
          if (!this.selectedNodes.some(n => n.key === node.key) && node.key.startsWith(`KMAT-${kmatId}-`)) {
            this.selectedNodes.push(node);
          }
        } else if (selectedChildren.length === 0 && partialChildren.length === 0) {
          node.partialSelected = false;
          // Remove parent from selectedNodes if no children are selected
          this.selectedNodes = this.selectedNodes.filter(n => n.key !== node.key);
        } else {
          node.partialSelected = true;
          // Remove parent from selectedNodes if partially selected
          this.selectedNodes = this.selectedNodes.filter(n => n.key !== node.key);
        }
      }
    });
  }
  // Recursively update parent selection based on children
  updateParentSelection(parent: TreeNode | null) {
    if (!parent) return;
    const siblings = parent.children || [];
    const allSelected = siblings.every(sib => this.selectedNodes.includes(sib));
    if (allSelected) {
      if (!this.selectedNodes.includes(parent)) {
        this.selectedNodes.push(parent);
      }
    } else {
      this.selectedNodes = this.selectedNodes.filter(n => n !== parent);
    }
    // Recursively check up the tree
    this.updateParentSelection(parent.parent);
  }

  addNewConfiguration() {
    let dialogRef = this.dialog.open(ConfigurationMvbloComponent, {
      height: '40%',
      width: '38%',
      panelClass: 'kmat-dialog-container',
      data: this.kmatVbloData
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != "" && result != undefined && !isNaN(result)) {
        const kmatId = Number(result);
          this.selectedKMAT = kmatId;
        console.log("Dialog result:", result);
         this.loadAllData( this.selectedKMAT,false).then(() => {
          if (this.gridApi) {
            this.gridApi.redrawRows();
            
          }

            this.scrollTreeToBottom();
        });
      }
    });
  }

  openAlertDialog(error) {
    this.dialog.open(AlertDialogComponent, { data: error })
  }

   private scrollTreeToBottom(retries: number = 6) {
    setTimeout(() => {
      const container: HTMLElement | null =
        this.vbloTree?.el?.nativeElement?.querySelector('.p-tree') ||
        this.vbloTree?.el?.nativeElement?.querySelector('.p-tree-wrapper') ||
        this.vbloTree?.el?.nativeElement;

      if (container && container.scrollHeight > 0) {
        container.scrollTop = container.scrollHeight;
      } else if (retries > 0) {
        this.scrollTreeToBottom(retries - 1);
      }
    }, 80);
  }

  canDeactivate() {
    return this.submitClicked;
  }

  onClickCancel() {
    this.hasUnsavedChanges = false;
    this.localStorageService.remove("configuration");
    this.router.navigate(["/tc-manageProject"]);
  }

  onClickBack() {
    this.hasUnsavedChanges = false;
    this.localStorageService.remove("configuration");
    this.router.navigate(["/tc-configuration"])
  }

  onClickNext() {
    this.submit();
  }

  // Call this when a KMAT primary radio button is changed
  onPrimaryKmatChange(kmatId: number) {
    if (Array.isArray(this.allKmatData)) {
      this.allKmatData.forEach(kmat => {
        kmat.Isprimary = (kmat.KMATId === kmatId);
      });
    }
  }

  /**
  * Get a dictionary of selected vbloMaterialIds for each selected KMAT
  * Returns: { [kmatId: number]: string[] }
  */
  getSelectedVbloMaterialIdsByKmat(): { [kmatId: number]: string[] } {
    const result: { [kmatId: number]: string[] } = {};
    Object.keys(this.kmatSelectionStore).forEach(kmatId => {
      const nodes = this.kmatSelectionStore[kmatId];
      if (Array.isArray(nodes)) {
        // Only extract vbloMaterialId from nodes with data and IsLinkedToMaterial
        result[Number(kmatId)] = nodes
          .filter(node => node.data?.VBLOMaterialId || node.key?.includes('-MAT-'))
          .map(node => node.data.VBLOMaterialId || null)
          .filter(id => !!id);
      }
    });
    return result;
  }

  submit(event?: any) {
    this.submitClicked = true;

    const selectedKmats = (this.allKmatData || []).filter(kmat => kmat.selected);

    if (selectedKmats.length === 0) {
      this.openAlertDialog([{ 'Please select at least one KMAT before submitting.': 'Validation Error' }]);
      this.submitClicked = false;
      return;
    }

    // Check currency diversity BEFORE forcing primary logic
    const currencies = Array.from(new Set(selectedKmats
      .map(k => k.Currency)
      .filter(c => c != null && c !== '')
    ));

    if (currencies.length > 1) {
      // Show confirmation and defer rest of submit until user responds
      this.confirmDifferentCurrencies(currencies);
      return;
    }

     // Proceed normally if currencies are uniform
    this.finalizeSubmit(selectedKmats);

    
  }


  // NEW: Ask user to confirm proceeding with mixed currencies
  private confirmDifferentCurrencies(currencies: string[]) {
    // const msg = ``;
    // const dialogRef = this.dialog.open(AlertDialogComponent, {
    //   data: [{ [msg]: 'Confirmation' }],
    //   disableClose: true
    // });

    this.openAlertDialog([{'Dear user, you selected two KMATs from different plants with different currencies. Please be aware that the shown values in the application are not being translated into a common currency. Therefore, shown sums are not correct, please use our Power BI reporting solution to see the values in Group Currency.':'Are you sure you want to continue?'}]);

     this.sharedService.configurationOnClickOk.subscribe(
            () => {
               const selectedKmats = (this.allKmatData || []).filter(kmat => kmat.selected);
        this.finalizeSubmit(selectedKmats);
            }
       );

     this.sharedService.configurationOnClickCancel.subscribe(
            () => {
              this.submitClicked = false;
            }
       );

    // NOTE: Adjust the comparison below to whatever value your AlertDialogComponent returns on OK.
    // dialogRef.afterClosed().subscribe(result => {
    //   if (result === 'Ok' || result === true) {
    //     const selectedKmats = (this.allKmatData || []).filter(kmat => kmat.selected);
    //     this.finalizeSubmit(selectedKmats);
    //   } else {
    //     this.submitClicked = false;
    //   }
    // });
  }

  private finalizeSubmit(selectedKmats: any[]) {
// If only one KMAT is selected, make it primary automatically
    if (selectedKmats.length === 1) {
      selectedKmats[0].Isprimary = true;
      this.lastPrimaryKmatId = selectedKmats[0].KMATId;
    } else {
      // For multiple KMATs, check if one is set as primary
      const selectedKmatPrimaries = selectedKmats.filter(kmat => kmat.Isprimary);
      if (!selectedKmatPrimaries.length) {
        this.openAlertDialog([{ 'Please select one KMAT as leading KMAT before submitting.': 'Validation Error' }]);
        this.submitClicked = false;
        return;
      }
    }

    const primaryKmatWasChanged = this.primaryKmatChanged;

    // Get selected KMATs and their primary flag
    const selectedKmatIds = (this.allKmatData || []).filter(kmat => kmat.selected).map(kmat => ({
      KMATId: kmat.KMATId
    }));

    // Get all selected material IDs by KMAT
    const selectedVbloMaterialIdsByKmat = this.getSelectedVbloMaterialIdsByKmat();

    // Prepare arrays for added and removed VBLOs
    this.configurationData.addedVblo = [];
    this.configurationData.removedVblo = [];
    this.configurationData.primaryKmatChanged = primaryKmatWasChanged;
    this.configurationData.primaryKmatId = this.lastPrimaryKmatId;

    // Added: Only items selected in UI but not present in backend
    Object.entries(selectedVbloMaterialIdsByKmat).forEach(([kmatId, selectedMaterialIds]) => {
      const kmatInfo = selectedKmatIds.find(k => k.KMATId == Number(kmatId));

      const backendMaterialIds = this.kmatBackendMaterialStore[kmatId] || [];

      // Added: Only items selected in UI but not present in backend
      const newlyAdded = selectedMaterialIds.filter(id => !backendMaterialIds.includes(id));
      this.configurationData.addedVblo.push(...newlyAdded.map(vbloMaterialId => ({
        kmatId: Number(kmatId),
        IsprimaryKmat: kmatInfo.KMATId == this.configurationData.primaryKmatId ? true : false,
        vbloMaterialId: vbloMaterialId
      })));
    });

    // Removed: Take from kmatUnselectedStore
    Object.entries(this.kmatUnselectedStore).forEach(([kmatId, unselectedIds]) => {
      const isPrimary = Number(kmatId) === this.configurationData.primaryKmatId;
      unselectedIds.forEach(vbloMaterialId => {
        this.configurationData.removedVblo.push({
          kmatId: Number(kmatId),
          IsprimaryKmat: isPrimary,
          vbloMaterialId: vbloMaterialId
        });
      });
    });

    // console.log("Added VBLO Data:", this.configurationData.addedVblo);
    // console.log("Removed VBLO Data:", this.configurationData.removedVblo);
debugger;
    this.localStorageService.set("configuration", this.configurationData);
    this.localStorageService.set("autoSubmitTcConfiguration", true);
    this.router.navigate(['/tc-configuration'])

  }
}
